export default __webpack_public_path__ + "static/media/ui-payment-type-small-master-card.527d18ec.svg";